import { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Link } from 'react-router-dom';
import CategoryIcon from '@mui/icons-material/Category';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import './Item.css';

const ItemEdit = () => {
    const { id } = useParams();
    const history = useHistory();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [errorMessage, setErrorMessage] = useState('');
    const [formData, setFormData] = useState({ name: '', gstRate: '' });

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) { logout(); return; }
    }, [isAuthenticated, companyId, token]);

    useEffect(() => {
        fetchData('CategoryApi', '/CategoryDetails/' + id, token)
            .then((r) => { if (r.responseCode === '1111') setFormData(r.response_data); })
            .catch((e) => console.error('Error fetching Category Details:', e));
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        updateData('CategoryApi', '' + id, { ...formData, UpdatedBy: userId }, token)
            .then(() => history.push('/ItemIndex'))
            .catch((e) => console.error('Error updating record:', e));
    };

    return (
        <div className="item-container">
            <div className="item-header-card">
                <div className="item-header-content">
                    <div className="item-title-section">
                        <span className="item-title-icon"><CategoryIcon fontSize="small" /></span>
                        <h1 className="item-title">Item Edit</h1>
                    </div>
                    <div className="item-header-actions">
                        <button className="it-btn it-btn-update" onClick={handleSubmit}>
                            <SaveIcon style={{ fontSize: 14 }} />&nbsp;Update
                        </button>
                        <Link to="/ItemIndex" className="it-btn it-btn-back">
                            <ArrowBackIcon style={{ fontSize: 14 }} />&nbsp;Back
                        </Link>
                    </div>
                </div>
            </div>

            {errorMessage && <div className="item-alert item-alert-error">{errorMessage}</div>}

            <div className="item-form-card">
                <p className="item-form-section-title">Item Information</p>
                <div className="item-form-row">
                    <div className="item-form-group w-3">
                        <label className="item-label">Item Name <span className="required">*</span></label>
                        <input className="item-input" name="name" value={formData.name} onChange={handleChange} type="text" placeholder="Enter item name" required maxLength={50} />
                    </div>
                    <div className="item-form-group">
                        <label className="item-label">GST Rate</label>
                        <input className="item-input text-right" name="gstRate" value={formData.gstRate} onChange={handleChange} type="number" placeholder="0" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ItemEdit;
